
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/building-in-public",
      function () {
        return require("private-next-pages/site/building-in-public.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/building-in-public"])
      });
    }
  